module.exports = __webpack_public_path__ + "img/icon-facebook.c3c2baad.svg";